<template>
  <v-icon dark :size="size" :color="getColor">close</v-icon>
</template>

<script>
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscCloseIcon',

  props: {
    size: {
      type: Number,
      default: 20,
    },
  },

  computed: {
    getColor() {
      return variables.gray600
    },
  },
}
</script>
